import React, { useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../../../footer.js";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Default Quill theme
import Header from "../../../header/header.js";
import Navvbar from "../../../header/Navvbar.js";


// Add custom toolbar options
const modules = {
    toolbar: [
        // Font style
        [{ font: [] }],
        // Text size
        [{ size: ["small", false, "large", "huge"] }],
        // Text formatting
        ["bold", "italic", "underline", "strike"],
        // Text alignment
        [{ align: [] }],
        // List options
        [{ list: "ordered" }, { list: "bullet" }],
        // Indentation
        [{ indent: "-1" }, { indent: "+1" }],
        // Color options
        [{ color: [] }, { background: [] }],
        // Clear formatting
        ["clean"],
    ],
};

const DDXWebsites = () => {
    const [content, setContent] = useState("");
    const [websiteColor, setWebsiteColor] = useState("Black");
    const [selectedServices, setSelectedServices] = useState({
        fixedRestorations: false,
        removableRestorations: false,
        dentalAppliances: false,
        implantRestorations: false,
        dentalWingServices: false,
        zirconiaCadCam: false,
        other: false,
    });

    const handleServiceChange = (event) => {
        const { name, checked } = event.target;
        setSelectedServices({
            ...selectedServices,
            [name]: checked,
        });
    };



    return (
        <>
            <Header />
            <Navvbar/>
            <br />
            <div style={{width: '95%',  margin: '0 auto' ,padding:"0px"}} >
                <div className="row">
                    {/* Sidebar */}
                  
                    <div className="col-md-2" style={{ borderRight: '1px solid #004aad'  }}>
    <h3 style={{marginLeft:"10px"}}>Promotions</h3>
    <div>
        <div style={{ marginBottom: "10px" }}>
            <Link to="/website" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '500',marginBottom: '10px',marginLeft:"15px"}}>DDX Websites</Link>
        </div>
        <div style={{ marginBottom: "10px" }}>
            <Link to="/ddxAdd" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '500',marginBottom: '10px',marginLeft:"15px"}}>DDX Ads</Link>
        </div>
        <div style={{ marginBottom: "10px" }}>
            <Link to="/coupon" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '500',marginBottom: '10px',marginLeft:"15px"}}>DDX Coupons</Link>
        </div>
        <div style={{ marginBottom: "10px" }}>
            <Link to="/widgets" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '500',marginBottom: '10px',marginLeft:"15px"}}>Widgets</Link>
        </div>
        <div style={{ marginBottom: "10px" }}>
            <Link to="/action" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '500',marginBottom: '10px',marginLeft:"15px"}}>Links</Link>
        </div>
        <div style={{ marginBottom: "10px" }}>
            <Link to="/ddxAccount" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '300',marginBottom: '10px',marginLeft:"15px",fontSize:"15px"}}>DDX Account Onboarding</Link>
        </div>
    </div>
</div>

                    {/* Main Content */}
                    <div className="col-md-10" style={{  width: "80%" }}>
                        <div className="main-content" >
                            <h3 style={{ fontWeight: "bold",marginTop:"20px" }} >DDX Websites</h3>
                            <br />
<h3>Overview</h3>
                            {/* Overview Section */}
                            <div className="mb-4" style={{ borderTop: "3px solid #004aad", backgroundColor: "#f0f0f0" }}>
    <br />
    <label style={{ fontWeight: "bold", marginLeft: "20px" }}>Your DDX URL: </label>
    <input
        style={{ width: "20%", marginLeft: "20px" }}
        type="text"
        className="form-control"
        defaultValue="https://hira.ddxdental.com"
    />

    <label className="mt-3" style={{ fontWeight: "bold", marginLeft: "20px" }}>Tagline:</label>
    <input type="text" className="form-control" style={{ width: "20%", marginLeft: "20px" }} />

    <label className="mt-3" style={{ fontWeight: "bold", marginLeft: "20px" }}>Website Color:</label>

    <select
        style={{ width: "20%", marginLeft: "20px" }}
        className="form-select"
        value={websiteColor}
        onChange={(e) => setWebsiteColor(e.target.value)}
    >
        <option value="Black">Black</option>
        <option value="White">White</option>
        <option value="Blue">Blue</option>
    </select>

    <label className="mt-3" style={{ fontWeight: "bold", marginLeft: "20px" }}>Lab Overview:</label>
    <p style={{ marginLeft: "20px" }}>Provide a brief overview of your lab. This content will be used to educate your customers on your unique business offering.</p>
</div>
                            <div style={{ margin: "20px", maxWidth: "800px", marginLeft: "0px",}}>
                                {/* Quill Editor */}
                                <ReactQuill
                                    theme="snow"
                                    value={content}
                                    onChange={setContent}
                                    modules={modules}
                                    placeholder="Start writing here..."
                                    style={{ height: "00px" }}
                                />
                                <br/>
                            </div>



                            {/* Lab Logo Section */}
                            <div className="mb-4">
                                <div>
                                    <img
                                        src={require('./hiralab.jpg')}
                                        alt="Lab Logo"
                                        className="img-fluid mb-3"
                                    />
                                    <h3>Lab Logo</h3>
                                    <div style={{ borderTop: "3px solid #004aad", backgroundColor: "#f0f0f0" }}>
    <br />
    <p style={{ marginLeft: "20px" }}>Upload your lab logo to personalize DDX for your customers.</p>
    <p style={{ marginLeft: "20px" }}>
        Logo formats accepted include PNG, JPEG, and GIF.<br />
        Your logo will be resized to 150px width x 50px height.
    </p>
    <p style={{ marginLeft: "20px" }}>Your current uploaded logo:</p>
    <img
        src={require('./image.jpg')}
        alt="Lab Logo"
        className="img-fluid mb-3"
        style={{ width: '125px', height: '80px', marginLeft: "20px" }} // Added marginLeft here
    />
    <input
        type="file"
        className="form-control mb-2"
        style={{ width: "25%", marginLeft: "20px" }} // Added marginLeft here
    /> 
    <br />
</div>
<br/>
                                <button className="btn" style={{ backgroundColor: "#004aad", color: "white" }}>Delete Logo</button>
                            </div>
                         <br/>
                            {/* Services Offered Section */}
                            <div className="mb-4">
                                <h3>Services Offered</h3>
                                <div style={{ borderTop: "3px solid #004aad", backgroundColor: "#f0f0f0" }}>
    <br />
    <form>
        {Object.keys(selectedServices).map((serviceKey) => (
            <div key={serviceKey} className="form-check" style={{ marginLeft: "20px" }}> {/* Added marginLeft to the form-check */}
                <input
                    type="checkbox"
                    className="form-check-input"
                    name={serviceKey}
                    checked={selectedServices[serviceKey]}
                    onChange={handleServiceChange}
                    style={{ marginLeft: "10px" }} // Optional: You can add margin here to shift the checkbox itself
                />
                <label className="form-check-label" style={{ marginLeft: "10px" }}> {/* Added margin to the label */}
                    {serviceKey
                        .replace(/([A-Z])/g, " $1")
                        .replace(/^./, (str) => str.toUpperCase())}
                </label>
            </div>
        ))}
    </form>
    <br/>
</div>

                            </div>
                            

                            {/* Save Button */}
                            <button className="btn" style={{ backgroundColor: "#004aad", color: "white" }} >Save</button>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <br/><br/><br/><br/>

            {/* Footer */}
            <div style={{width: '95%',  margin: '0 auto' ,padding:"0px"}}>
                <Footer />
            </div>
        </>
    );
};

export default DDXWebsites;
